<script>
export default {
  name: "ApplicationProgressTracker",
  props: {
    stages: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
};
</script>

<template>
  <div class="card border-0 shadow-sm">
    <div class="card-body px-3 px-lg-4 py-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h6 class="fw-bold mb-0">Application Tracker</h6>
        <!-- <span class="small text-muted">School fee is the final stage</span> -->
      </div>

      <div v-if="loading" class="placeholder-glow py-3">
        <span class="placeholder col-12 tracker-placeholder"></span>
      </div>
      <div v-else class="tracker" aria-label="Application progress">
        <div
          v-for="(stage, index) in stages"
          :key="stage.key"
          class="tracker-stage"
          :class="{
            completed: stage.completed,
            current: stage.current,
          }"
        >
          <div class="stage-marker" :aria-label="stage.label">
            <i v-if="stage.completed" class="bi bi-check-lg"></i>
            <span v-else>{{ index + 1 }}</span>
          </div>
          <span class="stage-label">{{ stage.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.tracker {
  display: grid;
  grid-template-columns: repeat(8, minmax(90px, 1fr));
  min-width: 820px;
  overflow: hidden;
}

.card-body {
  overflow-x: auto;
}

.tracker-stage {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 90px;
  color: #7a8086;
  text-align: center;
}

.tracker-stage:not(:last-child)::after {
  position: absolute;
  top: 16px;
  left: calc(50% + 18px);
  width: calc(100% - 36px);
  height: 3px;
  background: #dee2e6;
  content: "";
}

.tracker-stage.completed:not(:last-child)::after {
  background: #198754;
}

.stage-marker {
  z-index: 1;
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border: 2px solid #ced4da;
  border-radius: 50%;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
}

.completed .stage-marker {
  border-color: #198754;
  background: #198754;
  color: #fff;
}

.current .stage-marker {
  border-color: var(--bs-primary);
  box-shadow: 0 0 0 4px rgba(var(--bs-primary-rgb), 0.14);
  color: var(--bs-primary);
}

.stage-label {
  max-width: 115px;
  margin-top: 9px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.25;
}

.completed .stage-label,
.current .stage-label {
  color: #212529;
}

.tracker-placeholder {
  height: 55px;
}
</style>
